// NavigationContext.js
import React, { createContext, useContext, useState } from 'react';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
    const [previousPath, setPreviousPath] = useState('/');

    return (
        <NavigationContext.Provider value={{ previousPath, setPreviousPath }}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigation = () => useContext(NavigationContext);
